<template>
    <section class="px-3 lg:px-40 sm:py-12 py-32 background flex flex-col items-center justify-center sm:mb-24">
        <div class="w-full flex flex-col gap-2.5">
            <div class="grid grid-cols-1 lg:grid-cols-2 w-full gap-5">

                <div class="w-full flex flex-col justify-center content-center items-center">
                    <div class="sm:w-3/4">
                        <div class="font-medium mb-5">
                            <h2>{{ title }}</h2>
                        </div>
                        <div class="subtitle mb-4">
                            <p>{{ subtitle }}</p>
                        </div>
                        <div class="text-soft my-4">

                            <!-- Check if the data array has only one item -->
                            <p v-if="data && data.length === 1">{{ data[0] }}</p>

                            <!-- If the data array has more than one item, render it as a list -->
                            <ul v-else class="list-disc px-4">
                                <li v-for="(item, index) in data" :key="index">{{ item }}</li>
                            </ul>

                        </div>
                        <a v-if="button" :href="button.link"
                            class="w-fit btn text-left parent-arrow-icon btn-primary sm:text-center my-2">
                            <span v-if="button.title">{{ button.title }}</span>
                            <Icon class="arrow-icon" v-if="button.icon" :name="button.icon" />
                        </a>
                    </div>
                </div>

                <div class="overflow-hidden justify-center flex">
                    <img v-if="!mcp_code" :src="image_url" :alt="title || ''"
                        class="w-1/2 object-contain float-center animate-rotate-opacity" />
                    <McpCode v-else token="YOUR_TOKEN" connection="YOUR_CONNECTION_ID" />
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import { type PropType } from 'vue';
import type { IHeroButton } from './Hero.vue';
import { isDev } from '~/services/common';
import { capture } from '~/services/analytics';

export default {
    props: {
        title: String,
        subtitle: String,
        data: Array as PropType<string[]>,
        button: Object as PropType<IHeroButton>,
        posthog_view_event: String,
        posthog_view_properties: Object,
        image_url: String,
        mcp_code: Boolean,
    },
    methods: {
        click(posthog_click_event?: string, posthog_click_properties?: any) {
            if (isDev()) {
                return;
            }

            if (posthog_click_event) {
                capture(posthog_click_event, posthog_click_properties);
            }
        },
    },
    mounted() {
        if (this.posthog_view_event) {
            capture(this.posthog_view_event, this.posthog_view_properties);
        }
    },
};
</script>

<style>
@keyframes rotateOpacity {
    0% {
        transform: rotate(0deg);
        opacity: 1;
    }

    25% {
        opacity: 0.5;
    }

    50% {
        transform: rotate(180deg);
        opacity: 1;
    }

    75% {
        opacity: 0.5;
    }

    100% {
        transform: rotate(360deg);
        opacity: 1;
    }
}

.animate-rotate-opacity {
    animation: rotateOpacity 20s infinite;
}
</style>